import { FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { tokens } from "styles/Tokens";
import { helperTexts } from "utils/CommonConstants";
import "./RadioButton.scss";

interface props {
  label: string;
  options?: any;
  selectedOption?: any;
  handleChange: any;
  labelHelperText?: boolean;
  optionHelperText?: boolean;
}
const RadioButton = (props: props) => {
  const { label, options, selectedOption, handleChange, optionHelperText = false, labelHelperText = false } = props;
  return (
    <div className="radio-button-component">
      <div className="radio-button-label">
        {" "}
        <Typography variant="body2" color={tokens.Text.General.Secondary}>
          {label}
        </Typography>
        {labelHelperText && (
          <Typography variant="label" color={tokens.Text.General.Secondary} sx={{ padding: 0 }}>
            {helperTexts[label]}
          </Typography>
        )}
      </div>
      <FormControl className="radio-button-form-control">
        <RadioGroup defaultValue={selectedOption} onChange={handleChange} className="radio-button-group">
          {options?.map((option: any) => {
            return (
              <div className="radio-button-option" style={{ padding: "16px" }}>
                <FormControlLabel
                  className="radio-button-option-form"
                  value={option.value}
                  control={<Radio />}
                  label={
                    <>
                      <Typography variant="body2" color={tokens.Text.General.PrimaryHeadline}>
                        {option.label}
                      </Typography>
                    </>
                  }
                />
                {optionHelperText && (
                  <Typography variant="label" color={tokens.Text.General.Secondary} sx={{ padding: 0 }}>
                    {helperTexts[option.label]}
                  </Typography>
                )}
              </div>
            );
          })}
        </RadioGroup>
      </FormControl>
    </div>
  );
};
export default RadioButton;
